export default __webpack_public_path__ + "static/media/Icon-rightarrow.93663771.svg";